import { cn } from "design-system/utils"
import { Circle } from "lucide-react"

type Props = {
  className?: string
  containerClassName?: string
  isAnimated?: boolean
}

export const Pulse = ({ className, containerClassName, isAnimated = true }: Props) => {
  return (
    <div className={cn("flex flex-row items-center relative", containerClassName)}>
      <Circle
        className={cn("scale-75 fill-chart-1 stroke-0", isAnimated && "animate-ping", className)}
        style={{ animationDuration: "2000ms" }} // NOTE: Can't set it using tailwind
        size={12}
      />
      <Circle className={cn("scale-75 absolute fill-chart-1 stroke-0", className)} size={12} />
    </div>
  )
}
